<template>
  <Breadcrumbs
      title="GRN Request"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Goods Received Note', path: '/grn' },
      { label: 'GRN Request', path: '/grn-request' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <goodReceivedNote />
    </div>
  </div>
</template>

<script>
import goodReceivedNote from "@/pages/stock/grn/grnForm.vue";

export default {
  name: 'indexList',
  components: {
    goodReceivedNote,
  },
}
</script>
